import {RouteDefinition} from '../../../routes';
import {HomepageListScreen} from './HomepageListScreen';
import {HomepageEditScreen} from './HomepageEditScreen';

export const HomepageSettingsRoutes: RouteDefinition[] = [
    {
        routerLink: '/settings/homepage',
        component: HomepageListScreen,
    },
    {
        routerLink: '/settings/homepage/edit/:id',
        component: HomepageEditScreen,
    },
    {
        routerLink: '/settings/homepage/edit',
        component: HomepageEditScreen,
    },
];
